<template>
  <b-modal id="conflictswin" title="Конфликты синхронизации расписания" size="lg" :ok-only="true" ok-title="Закрыть" @show="fetchConflicts">
    <b-alert :show="!loading && unresolved.length == 0" variant="success">
      Активных конфликтов нет.
    </b-alert>
    <b-alert :show="!!errorMessage" variant="danger">{{ errorMessage }}</b-alert>

    <div v-if="unresolved.length > 0" class="mb-4">
      <h6>Требуют решения</h6>
      <b-table :items="unresolvedItems" :fields="fields" small responsive="sm">
        <template #cell(actions)="{ item }">
          <b-button size="sm" variant="outline-secondary" class="mr-2"
            :disabled="resolvingId == item.id"
            @click="resolve(item, 'keep_local')">Оставить локальную запись</b-button>
          <b-button v-if="item.kind == 'protected_slot_occupied'" size="sm" variant="primary"
            :disabled="resolvingId == item.id"
            @click="resolve(item, 'use_remote')">Применить с сайта</b-button>
        </template>
      </b-table>
    </div>

    <div v-if="resolvedRecent.length > 0">
      <h6>Недавние изменения</h6>
      <b-table :items="resolvedRecentItems" :fields="recentFields" small responsive="sm"></b-table>
    </div>
  </b-modal>
</template>

<script>
const PATH = process.env.VUE_APP_PATH;

const KIND_LABEL = {
  content_changed: 'Изменение расписания (применено автоматически)',
  protected_slot_occupied: 'Занятие с сайта конфликтует с вашей записью',
}

const RESOLUTION_LABEL = {
  applied_remote: 'применено с сайта',
  kept_local: 'оставлена локальная запись',
}

// _rowVariant — цвет строки b-table: danger для protected_slot_occupied
// (требует решения пользователя), warning для content_changed
// (информационно, но стоит обратить внимание) — та же схема, что и у
// _rowVariant в xlsxImport.vue.
function rowVariant(kind) {
  if (kind == 'protected_slot_occupied') return 'danger'
  if (kind == 'content_changed') return 'warning'
  return ''
}

function lessonLabel(lesson) {
  if (!lesson) return ''
  return lesson.predm || '(пусто)'
}

export default {
  name: 'conflictsWin',
  props: {
    login: String,
    passwordAES: String,
  },
  data() {
    return {
      loading: false,
      errorMessage: '',
      resolvingId: null,
      unresolved: [],
      recent: [],
      fields: [
        { key: 'day', label: 'День' },
        { key: 'time', label: 'Пара' },
        { key: 'description', label: 'Что произошло' },
        { key: 'actions', label: '' },
      ],
      recentFields: [
        { key: 'day', label: 'День' },
        { key: 'time', label: 'Пара' },
        { key: 'description', label: 'Что произошло' },
        { key: 'resolutionLabel', label: 'Решение' },
      ],
    }
  },
  computed: {
    resolvedRecent() {
      return this.recent.filter(c => c.resolved)
    },
    unresolvedItems() {
      return this.unresolved.map(c => ({
        ...c,
        description: `${KIND_LABEL[c.kind] || c.kind}: ${lessonLabel(c.local_lesson)} -> ${lessonLabel(c.remote_lesson)}`,
        _rowVariant: rowVariant(c.kind),
      }))
    },
    resolvedRecentItems() {
      return this.resolvedRecent.map(c => ({
        ...c,
        description: `${KIND_LABEL[c.kind] || c.kind}: ${lessonLabel(c.local_lesson)} -> ${lessonLabel(c.remote_lesson)}`,
        resolutionLabel: RESOLUTION_LABEL[c.resolution] || c.resolution || '',
        _rowVariant: rowVariant(c.kind),
      }))
    },
  },
  methods: {
    async fetchConflicts() {
      if (!this.login) return
      this.loading = true
      this.errorMessage = ''
      try {
        const response = await this.axios.post(PATH + '/api/rasp/conflicts', {
          login: this.login,
          passwordAES: this.passwordAES,
        })
        this.unresolved = response.data.unresolved || []
        this.recent = response.data.recent || []
        this.$emit('count-changed', this.unresolved.length)
      } catch (e) {
        this.errorMessage = 'Не удалось загрузить список конфликтов.'
      } finally {
        this.loading = false
      }
    },
    async resolve(item, resolution) {
      this.resolvingId = item.id
      this.errorMessage = ''
      try {
        await this.axios.post(PATH + '/api/rasp/conflicts/resolve', {
          login: this.login,
          passwordAES: this.passwordAES,
          id: item.id,
          resolution,
        })
        await this.fetchConflicts()
        this.$emit('resolved')
      } catch (e) {
        this.errorMessage = 'Не удалось применить решение по конфликту.'
      } finally {
        this.resolvingId = null
      }
    },
  },
}
</script>
